import React from 'react';
import Dropdown, { OPERATING_MODEL } from '@modules/insights/insightsDropdown';

import { Button } from 'antd';
import HexagonGrid from '@components/hexagonGrid';
import DetailContainer from '@modules/insights/OperatingModel/detailContainer';

function OperatingModelView({
  dataIsValid,
  operatingModel: data,
  selectedId,
  onClickHandler,
  detailTitle,
  detailBody,
  setIsEditMode,
}) {
  const isInternal = JSON.parse(
    window.localStorage.userInfo || '{}',
  ).isInternal;

  return (
    <div className="insights-operating-model">
      <div className="insights-operating-model-left">
        <Dropdown section={OPERATING_MODEL} />
        {isInternal && (
          <Button
            className="insights-operating-model-button"
            onClick={setIsEditMode}
            type="primary"
          >
            EDIT
          </Button>
        )}
        <div className="insights-operating-model-content">
          {dataIsValid && (
            <div className="insights-operating-model-hexagonContainer">
              <HexagonGrid
                data={data}
                selectedId={selectedId}
                onClickHandler={onClickHandler}
              />
            </div>
          )}
        </div>
      </div>
      <div className="insights-operating-model-right">
        {dataIsValid && detailBody && (
          <div className="insights-operating-model-detailContainer">
            <DetailContainer title={detailTitle} body={detailBody} />
          </div>
        )}
      </div>
    </div>
  );
}

export default OperatingModelView;
